import React, { useContext, useEffect, useState } from 'react';
import { ZdsDivider, ZdsDwellingCard } from '@zig-design-system/ui-components-react';
import Translation from '../../../../Shared/components/Translation';
import UnitFormatService from '../../../services/UnitFormatService';
import { RootContext } from '../../../../Context/RootContext';
const DwellingCard = ({ unit, url, currentView, bodyPadded }) => {
    var _a;
    const dwellingCardRef = React.useRef(null);
    const [imageNotFoundError, setImageNotFoundError] = useState(false);
    const assetPaths = useContext(RootContext).assetPaths;
    const imageNotFoundUrl = assetPaths.sitepackage + '/Images/imagenotfound_4x3.jpg';
    useEffect(() => {
        dwellingCardRef.current.addEventListener('zdsClick', handleScroll);
        return () => {
            var _a;
            (_a = dwellingCardRef === null || dwellingCardRef === void 0 ? void 0 : dwellingCardRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('zdsClick', handleScroll);
        };
    }, []);
    const handleScroll = ((event) => {
        sessionStorage.setItem('dwellingCardScrollY', window.scrollY.toString());
    });
    const imageSrc = unit.list_image || imageNotFoundUrl;
    const actionLabel = unit.status || unit.search_model;
    return (React.createElement("div", null,
        React.createElement(ZdsDwellingCard, Object.assign({}, (currentView === 'tiles'
            ? {
                horizontal: false,
                streetHighlighted: false,
                priceHighlighted: false,
            }
            : {}), (currentView === 'list'
            ? {
                horizontal: true,
                streetHighlighted: true,
                priceHighlighted: true,
            }
            : {}), { street: (_a = unit.street) !== null && _a !== void 0 ? _a : unit.name, houseNumber: unit.street
                ? UnitFormatService.formatHouseNumberAndAddition(unit.house_number, unit.house_number_addition)
                : null, city: unit.city, district: unit.quarter, price: UnitFormatService.getPrice(unit), "price-incl": UnitFormatService.getPriceIncl(unit), link: url, ref: dwellingCardRef, bodyPadded: bodyPadded }),
            React.createElement("img", { slot: "media", src: imageSrc, onError: ({ currentTarget }) => {
                    if (!imageNotFoundError) {
                        currentTarget.src = imageNotFoundUrl;
                        setImageNotFoundError(true); // sets the value to true after attempting to load fallback image
                    }
                }, alt: "", width: "293", height: "219", loading: "lazy" }),
            actionLabel && (React.createElement("div", { slot: "status", className: "zds-bg-secondary" }, actionLabel)),
            unit.house_type && React.createElement("span", { slot: "description" }, unit.house_type),
            unit.bedrooms && (React.createElement("span", { slot: "description" },
                unit.bedrooms,
                ' ',
                unit.bedrooms === 1 ? (React.createElement(Translation, { item: "tx_zigrealestate.details.bedroom" })) : (React.createElement(Translation, { item: "tx_zigrealestate.details.bedrooms" }))))),
        currentView === 'list' && React.createElement(ZdsDivider, { className: "zds-margin-y-4" })));
};
export default DwellingCard;
